/**
 * single-evenement.js
 */

// Import
import "./single-evenement.scss";
import $ from 'jquery';

$(document).ready(function() {

    // Prix min / max
    $('.evenement-template-default .prix div').each(function() {
        var prix = $(this);
        var prixTexte = prix.text();
        var indexofpoint = prixTexte.indexOf(".")+1;
        var indexofdollar = prixTexte.indexOf("$");
        var decimal = prixTexte.substring(indexofpoint, indexofdollar);
        var newPrixTexte = prixTexte.replace('.'+decimal, '<span>'+decimal+'</span>');
        prix.html(newPrixTexte);
    });



});



